import { HTTP_REQUEST_HEADER, HTTP_RESPONSE_HEADER } from "../../semantic-conventions";
export function httpRequestHeaderKey(key) {
    return `${HTTP_REQUEST_HEADER}.${key.toLowerCase()}`;
}
export function httpResponseHeaderKey(key) {
    return `${HTTP_RESPONSE_HEADER}.${key.toLowerCase()}`;
}
